import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Note } from 'ui/icons';
import { colors } from 'ui/theme';

import { NODE_TYPES } from '../../../constants';
import { getNodes } from '../../../ducks';
import { useNotesVisibility } from '../../../hooks';
import { NotesButton } from '../Footer.styles';

export const TOGGLE_NOTES_VISIBILITY_BTN_TEST_ID = 'toggle-notes-visibility-button';

export const NoteVisibilityToggleButton = () => {
  const [isNotesVisible, setIsNotesVisible] = useNotesVisibility();
  const nodes = useSelector(getNodes);

  const numNotes = useMemo(() => {
    return nodes ? nodes.filter(({ type }) => type === NODE_TYPES.NOTE).length : 0;
  }, [nodes]);

  const handleNoteToggleClick = () => {
    setIsNotesVisible(!isNotesVisible);
  };

  return (
    <NotesButton data-test={TOGGLE_NOTES_VISIBILITY_BTN_TEST_ID} onClick={handleNoteToggleClick}>
      <Note width={16} color={colors.textSecondary} backgroundColor={colors.white} />
      {isNotesVisible ? 'Hide' : 'Show'} {numNotes} note{numNotes === 1 ? '' : 's'}
    </NotesButton>
  );
};

export default NoteVisibilityToggleButton;
